import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';
import { RegisterOptions, useController, useFormContext } from 'react-hook-form';

export type Props = TextFieldProps & {
  name: string;
  label: string;
  rules?: RegisterOptions;
  type?: React.HTMLInputTypeAttribute;
  placeholder?: string;
  helperText?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TextInputField = ({ name, label, type, rules, placeholder, helperText, onChange: customOnChange, ...rest }: Props) => {
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    control,
    name,
    rules,
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(event); // react-hook-form handler
    if (customOnChange) {
      customOnChange(event); // custom handler
    }
  };

  return (
    <TextField
      fullWidth
      variant="outlined"
      label={label}
      type={type}
      placeholder={placeholder}
      error={fieldState.invalid}
      helperText={fieldState.error?.message|| helperText}
      required={rules && Object.keys(rules).includes('required')}
      value={field.value}
      onChange={handleChange}
      onBlur={field.onBlur}
      {...rest}
    />
  );
};

export default TextInputField;
